// extracted by mini-css-extract-plugin
export default {"Container":"_Container--Be67p","Img":"_Img--i3Aa1","Buttons":"_Buttons--p51t7"};